// extracted by mini-css-extract-plugin
module.exports = {"root":"skeleton_root__Atvrr","logo":"skeleton_logo__E81J3","content":"skeleton_content__eXZl1","column":"skeleton_column__iBKD9","item":"skeleton_item__EO6Wf"};